export default __webpack_public_path__ + "static/media/ra-tropic-disconected-c.2c026b54.svg";